/**
 * Công thức chi dự phòng
 */
export default {
  RegularInvest: 1,
  Regular: 2,
  Before: 3,
  Setting: 4
};
